import React, { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import image1 from '../image/articles/article6.webp';
import image2 from '../image/articles/article61.webp';
import image3 from '../image/articles/article62.webp';
import image4 from '../image/articles/article63.webp';
import image5 from '../image/articles/article64.webp';
import image6 from '../image/articles/article65.webp';
import image7 from '../image/articles/article66.webp';
import image8 from '../image/articles/article68.webp';
import image9 from '../image/articles/article69.webp';
import image13 from '../image/articles/article666.webp';
import image10 from '../image/articles/article663.webp';
import image11 from '../image/articles/article664.webp';
import image12 from '../image/articles/article665.webp';
import creative3Thumbnail from '../image/articles/creative3-1.webp';
import article5MainImage from '../image/articles/article5.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { QuoteBlock } from "../components/QuoteBlock";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';

function Article6(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const images2 = [image2, image3, image4 ]; 
      const images3 = [image5, image6, image7 ];
      const images4 = [image10, image11, image12];
      const images5 = [image8, image9, image13 ];
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ARTICLE6_PASSWORDS
      );
      
      useMetaTags({
        title: '2025년 회고 - Lynkim',
        description: '2025년을 한 마디로 정의하자면 / 1년 뒤 2026년을 돌아봤을 때',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'2025년 회고'}
              titleEn={'2025 Year in Review'}
              description={<div>2025년을 한 마디로 정의하자면 / 1년 뒤 2026년을 돌아봤을 때</div>}
              descriptionEn={<div>Defining 2025 in one phrase / Looking back from 2026, one year later</div>}
              category={'essay'}
              date={'2025.01.18.'}
              thumbnail={image1}/>
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection
                title = '2025년을 한 마디로 정의하자면'
                description= {<div>
                    2025년이 되면서, 새 해 목표한 것은 <b>“천진난만”</b>한 모습으로 살아가자라는 것이였다. 천진난만하다라는 것에 나름의 정의가 있었다. <br/>

                    세상을 긍정적으로 밝은 면을 많이 볼 줄 아는 것, 작은 것에도 감사하고 행복을 느끼는 것, 현실을 계산적으로만 바라보지 않고 원하는 삶의 모습을 찾아가며 나의 속도로 살아가는 것, 사람들과 어울어지며 즐거움을 함께 공유하는 것을 나만의 천진난만함으로 정의했고, 그렇게 살아가자고 다짐했다. <br/>

                    새 해가 되어서 가장 먼저 했던 것은 하고 싶었던 타투를 처음 팔에 새긴 것이다. 내가 좋아하는 것, 나만의 의미를 담고 있는 것으로 나의 이미지를 만들고 싶었는데, 그 때 새긴 것이 “미나리아재비”라는 작은 들꽃이었다. <br/>

                    “천진난만함”이라는 꽃말을 가진 작은 들꽃이 내가 원하는 나의 모습을 보여주는 것 같았다. <br/><br/>
                    2025년 동안에는 하고 싶은 것을 많이 실천하며 살아왔다. 계졀의 변화를 더 많이 느끼며 온전히 만끽했다. 겨울에는 추운 눈 속에서 따뜻하게 불을 피워놓고, 차가운 바람을 맞았고, 봄에는 새노랗게 피어나는 잎을 봤고, 여름에는 뜨거운 햇살을 맞으면서 수영을 했고, 가을에는 높은 하늘을 빼곡히 매운 단풍을 보면서 걸었다. <br/>
                    

                    </div>}
                marginBottom={true}
            />
            
            <ArticleImageLayout images={images2} />
            <ArticleImageLayout images={images3} />

            <ArticleTextSection
                description= {<div>

                    하고 싶었던 것들도 마음껏 했다. 보드게임을 만들어서 사람들을 모아 함께 어울릴 수 있도록 파티를 주최해서 즐겼다. 밤늦게 같이 온라인 게임도 하고, 여전히 합주도 했고, 펜싱도, 당구도, 피겨스케이팅도 했다.<br/>
                    두려움도 많이 극복하고, 무서움을 이기고 도전을 많이 했는데, 그 중 가장 기특하다고 생각한 것은 회사에서 대선 프로젝트에 지원한 것과 팀이동을 해서 새로운 환경에서 새로운 역할을 맡은 것이다. 도전을 하면서 내가 지금까지 혹시나 잘못해서 부끄러움을 느낄까봐 사람들에 대한 나의 평판을 걱정했다는 것을 알게 되었다. 앞으로는 나의 바닥이 드러나는 것을 두려워하지말고, 비춰지는 모습보다 나에게 집중하고 그 두려움을 이겨낼 수 있는 단단함을 키워야 겠다. <br/>

                    </div>}
            />
             <ArticleImageLayout images={images5} />
            <ArticleImageLayout images={images4} />
            <ArticleTextSection
                description= {<div>

                    돌아보면서 가장 반성한 것은 “꾸준함”이 많이 부족하다는 것이었다. 많은 것에 관심을 갖고 시도해보지만, 결과를 만들어내기 까지의 지루함과 고민, 어려움을 이겨내는 힘이 많이 부족했다. <br/>

                    게임을 만들 때도 계획은 즐거워했지만 실행하고 작은 부분들을 하나하나 만들어내는 과정을 귀찮아했다. 그 과정에서 즐거움이 없더라도 시작한 것에 대해 끝까지 최선을 다해 지루함을 이겨내고 마무리 짓는 연습을 더 많이 해야겠다.
                    </div>}
            />

            <CalloutLink href='http://lynkim.me/creative3' target='_blank' > 첫 서바이벌 게임 만들기</CalloutLink>
            
            <ArticleTextSection 
                marginTop={true}
                title = '1년 뒤 2026년을 돌아봤을 때'
                description=
                  {<div>
                    2025년이 나의 천진난만한 모습을 찾아보자라는 것이였다면, 2026년에는 거절에 대한 두려움, 다른 사람들의 평가를 이겨내고 내면을 단단한 사람으로 가꿔나가고 싶다. 지금 도전하는 일에 대해 가끔 무섭고, 힘들고, 지루함을 느끼더라도 다시 마음을 다잡고, 원하는 것을 이루어내기 위해 꾸준함을 유지해서 마지막 결과를 내볼 수 있는 사람이 되고 싶다. <br/>

                    변화에 대해 무서움을 느껴서 결정을 미루지 말고, 중요한 결정에 대해 우유부단하게 행동하지 말자. 귀찮아서, 혹은 부끄러워서 하고 싶은 것을 포기하지 말자. 5년 뒤 나의 삶의 방향이 뚜렷해지는 것에 나의 시간들을 집중해서 사용하자.<br/>

                    <br/>

                    올해는 먼저 삶의 안정성을 유지할 수 있도록 나의 전문성을 키워 직업으로서의 경쟁력을 갖춰나가고 싶다. 지금까지 약 8년간 디자이너로서, PM으로서 많은 경험을 쌓아보는 시간이였다면, 앞으로는 경쟁력을 갖춘 디자이너로서 어떤 곳에 가더라도 회사의 변화를 믿고 맡길 수 있는 디자이너가 되고 싶다. 상반기에는 다양한 환경에서의 디자이너 역할에 대한 경험과 매니저로서의 역량을 쌓기 위해 가장 적합한 회사로 이동할 예정이다. 이후에는 한국보다도 더 다른 환경에서 경험을 쌓아서 경쟁력을 쌓아보면 좋겠다. 그러기 위해서는 언어공부에 시간을 더 많이 내서 꾸준히 실력을 늘려나가야 겠다. <br/>

                    <br/>

                    건강에 대해서도 잘 챙기고 싶다. 매일 10분이라도 운동하면서 건강도, 심리적 안정도 찾아가며 너무 소진만 하지말고 건강도 잘 유지해나가자. 하고 싶었던 스포츠도 하나 꾸준히 지속하고 싶다. 예전에 너무 좋아해서 시간을 쏟았던 피겨스케이팅을 다시 시작해보자. <br/>

                    <br/>

                    올해는 하고 싶었던 나만의 일에서 결과를 만들어보고 싶다. 보드게임을 만들자고 했던 것에 대해 꼭 최종 결과물을 만들어서 사람들에게 보여주고, 내가 만든 결과물을 세상 사람들이 즐겨주는 것을 꼭 보고싶다.
                    </div>} 
                 marginBottom={true}
            />
         

            
          
          <NextItem to='/Article5' thumbnail={article5MainImage} nextProjectTitle='25.11. 회고'/>

          <BackButton/>
         
        </div>
        </ProtectedPage>
        </>
      )
  }
  
  export default Article6;
